import React from 'react'

import { AnimationProvider } from 'components/AnimationProvider'
import { BottomBar } from 'components/BottomBar'
import { PostPaymentProgressBar } from 'components/PostPaymentProgressBar'
import { useSectionedProgress } from 'components/SectionedProgressBar'

import { usePageConfig } from 'hooks/usePageConfig'

import { CommonLayout, Viewport, Wrapper } from 'common-styles'

type TProps = {
  children: React.ReactNode
  isHeaderOverlay?: boolean
  hasHeader?: boolean
  isAnimation?: boolean
}

export const PageShell: React.FC<TProps> = ({
  children,
  isHeaderOverlay = false,
  hasHeader = false,
  isAnimation = true,
}) => {
  const { pageBackground, fillsViewport, hasHeaderOffset } = usePageConfig()
  const { hasSectionedProgress } = useSectionedProgress()

  const content = (
    <Wrapper>
      <Viewport
        $fillsViewport={fillsViewport}
        $hasHeaderOffset={hasHeaderOffset}
      >
        <PostPaymentProgressBar />
        {children}
      </Viewport>

      <BottomBar />
    </Wrapper>
  )

  return (
    <CommonLayout
      $background={pageBackground}
      isHeaderOverlay={isHeaderOverlay}
      hasHeader={hasHeader}
      $hasSectionedProgress={hasSectionedProgress}
    >
      {isAnimation ? <AnimationProvider>{content}</AnimationProvider> : content}
    </CommonLayout>
  )
}
